import { useEffect, useState } from "react";
import { getSalesItems } from "../../api/salesApi";
import CoinsHeader from "../../components/Sales/CoinsHeader";
import Pagination from "../../components/MiniComponents/Pagination";
import "./Sales.css";

export default function Sales() {
  const [loading, setLoading] = useState(false);
  const [histories, setHistories] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filter, setFilter] = useState(null);
  const [type, setType] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await getSalesItems(page, filter, type);

      if (res?.success) {
        setHistories(res.data.histories || []);
        setTotalPages(res.data.totalpages || 1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, filter, type]);

  return (
    <div className="sales-transaction-page">
      <div className="sales-transaction-content">
        <div className="sales-header">
          <div>
            <h2>Sales & Transactions</h2>
            <p>View purchase history, transactions, and inventory sales.</p>
          </div>
        </div>
        <div className="sales-transaction-card">
          <div className="sales-transaction-filters">
            <div className="sales-transaction-filter-group">
              <label>Purchase Type</label>
              <select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="">All</option>
                <option value="ads">Ads</option>
                <option value="coins">Coins</option>
                <option value="googlePlay">Googleplay</option>
              </select>
            </div>

            <div className="sales-transaction-filter-group">
              <label>Item Type</label>
              <select value={type} onChange={(e) => setType(e.target.value)}>
                <option value="">All</option>
                <option value="coin">Coin</option>
                <option value="snakeSkin">Snake Skin</option>
                <option value="background">Background</option>
                <option value="chest">Chest</option>
                <option value="powerUp">Power Up</option>
              </select>
            </div>
          </div>
          <div className="sales-transaction-table-header">
            <div>SRN</div>
            <div>User ID</div>
            <div>Item Name</div>
            <div>Item Type</div>
            <div>Count</div>
            <div>Price</div>
            <div>Purchased By</div>
            <div>Purchased At</div>
          </div>

          <div className="sales-transaction-table-wrapper">
            <div className="sales-transaction-table-min-width">
              {loading ? (
                <div className="sales-transaction-table-message">
                  Loading transactions...
                </div>
              ) : histories.length === 0 ? (
                <div className="table-message">No transactions found.</div>
              ) : (
                histories.map((item) => (
                  <div key={item._id} className="sales-transaction-table-row">
                    <div>{item.s_no}</div>

                    <div className="truncate">{item.userId}</div>

                    <div>{item.itemName}</div>

                    <div>
                      <span className="badge">{item.itemType}</span>
                    </div>

                    <div>{item.itemCount}</div>

                    <div>₹{item.price}</div>

                    <div>{item.purchasedBy}</div>

                    <div className="sales-transaction-date">
                      {new Date(item.purchasedAt).toLocaleString()}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* {totalPages > 1 && (
            <div className="pagination-wrapper">
              <button
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Prev
              </button>

              <span>
                Page {page} of {totalPages}
              </span>

              <button
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          )} */}
          <div className="sales-transaction-pagination-wrapper">
            {totalPages > 1 && (
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                onPageChange={(p) => setPage(p)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
